export const keyboardShortcuts = {
  // Global shortcuts
  global: {
    'ctrl+k': {
      action: 'search',
      description: 'Search',
      category: 'Global'
    },
    'ctrl+shift+k': {
      action: 'command_palette',
      description: 'Command Palette',
      category: 'Global'
    },
    'alt+shift+r': {
      action: 'refresh',
      description: 'Refresh',
      category: 'Global'
    }
  },

  // Navigation shortcuts
  navigation: {
    'alt+1': {
      action: 'dashboard',
      description: 'Go to Dashboard',
      category: 'Navigation'
    },
    'alt+2': {
      action: 'sales',
      description: 'Go to Sales',
      category: 'Navigation'
    },
    'alt+3': {
      action: 'customers',
      description: 'Go to Customers',
      category: 'Navigation'
    },
    'alt+4': {
      action: 'items',
      description: 'Go to Items',
      category: 'Navigation'
    },
    'alt+5': {
      action: 'reports',
      description: 'Go to Reports',
      category: 'Navigation'
    }
  },

  // Form shortcuts
  form: {
    'ctrl+s': {
      action: 'save',
      description: 'Save',
      category: 'Form'
    },
    'ctrl+enter': {
      action: 'save_and_new',
      description: 'Save and New',
      category: 'Form'
    },
    'esc': {
      action: 'cancel',
      description: 'Cancel',
      category: 'Form'
    }
  },

  // List shortcuts
  list: {
    'ctrl+n': {
      action: 'new',
      description: 'New Record',
      category: 'List'
    },
    'ctrl+f': {
      action: 'filter',
      description: 'Filter',
      category: 'List'
    },
    'ctrl+p': {
      action: 'print',
      description: 'Print',
      category: 'List'
    }
  }
};

export const getShortcutsByCategory = () => {
  const categories = {};
  Object.values(keyboardShortcuts).forEach(category => {
    Object.entries(category).forEach(([key, value]) => {
      if (!categories[value.category]) {
        categories[value.category] = [];
      }
      categories[value.category].push({
        key,
        ...value
      });
    });
  });
  return categories;
}; 